import { render, staticRenderFns } from "./RoomImage.vue?vue&type=template&id=63e14692"
import script from "./RoomImage.vue?vue&type=script&lang=js"
export * from "./RoomImage.vue?vue&type=script&lang=js"
import style0 from "./RoomImage.vue?vue&type=style&index=0&id=63e14692&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports